
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsSubCategory1Dialog extends Serenity.EntityDialog<CsSubCategory1Row, any> {
        protected getFormKey() { return CsSubCategory1Form.formKey; }
        protected getIdProperty() { return CsSubCategory1Row.idProperty; }
        protected getLocalTextPrefix() { return CsSubCategory1Row.localTextPrefix; }
        protected getNameProperty() { return CsSubCategory1Row.nameProperty; }
        protected getService() { return CsSubCategory1Service.baseUrl; }
        protected getDeletePermission() { return CsSubCategory1Row.deletePermission; }
        protected getInsertPermission() { return CsSubCategory1Row.insertPermission; }
        protected getUpdatePermission() { return CsSubCategory1Row.updatePermission; }

        protected form = new CsSubCategory1Form(this.idPrefix);


        protected afterLoadEntity() {
            super.afterLoadEntity(); 
           
            // var Catcode2 = Q.tryFirst(CsSubCategory2Row.getLookup().items, x=> x.SubCat1Code == this.entity.SubCat1Code);
            // if(Catcode2 != null){
            //     this.deleteButton.toggleClass('disabled', true);
               
            // }
            var Skucheck = Q.tryFirst(CsSkuRow.getLookup().items, x=> x.SubCat1Code == this.entity.SubCat1Code);            
            if (Skucheck != null) {
                this.deleteButton.toggleClass('disabled', true);
               
                
            }
            //console.log(Catcode2)
        }
        
    }
}